import * as THREE from "./three.module.js";

const DAMPING = 0.03;
export const DRAG = 1 - DAMPING;
export const MASS = 0.4;
export const segmentsCountX = 20;
export const segmentsCountY = 30;
export const restDistanceX = 18 * 10 / segmentsCountX;
export const restDistanceY = 28 * 10 / segmentsCountY;
export const yTileDiff = 28 / 20;
export const GRAVITY = 981 * 1.4;
export const TIMESTEP = 18 / 1000;
export const TIMESTEP_SQ = TIMESTEP * TIMESTEP;
export const gravity = new THREE.Vector3(0, -GRAVITY, 0).multiplyScalar(MASS);
export const textures = [
    {
        d: '/textures/test/b4047d19-6778-4ee5-a27f-5e8bae5aa4f2_COL_result.jpg',
        n: '/textures/test/b4047d19-6778-4ee5-a27f-5e8bae5aa4f2_NRM_result.jpg',
        r: '/textures/test/b4047d19-6778-4ee5-a27f-5e8bae5aa4f2_ROUGH_result.jpg',
        s: '/textures/test/b4047d19-6778-4ee5-a27f-5e8bae5aa4f2_SPEC_result.jpg'
    },
    {
        d: 'textures/bd_wd_draper_draper_21-scuba_d_4.jpg',
        a: 'textures/bd_wd_draper_draper_21-scuba_a_4.jpg',
        n: 'textures/bd_wd_draper_draper_21-scuba_n_4.jpg',
        r: 'textures/bd_wd_draper_draper_21-scuba_r_4.jpg',
        s: 'textures/bd_wd_draper_draper_21-scuba_s_4.jpg'
    }, {
        d: 'textures/bd_br_milltown_dundrum_03-sand/bd_br_milltown_dundrum_03-sand_d_8.jpg',
        n: 'textures/bd_br_milltown_dundrum_03-sand/bd_br_milltown_dundrum_03-sand_n_8.jpg',
        s: 'textures/bd_br_milltown_dundrum_03-sand/bd_br_milltown_dundrum_03-sand_s_8.jpg',
        repreat: 10
    }, {
        d: 'textures/bd_br_mont-blanc_mont-blanc_15-sunflower/bd_br_mont-blanc_mont-blanc_15-sunflower_d_4.jpg',
        n: 'textures/bd_br_mont-blanc_mont-blanc_15-sunflower/bd_br_mont-blanc_mont-blanc_15-sunflower_n_4.jpg',
        s: 'textures/bd_br_mont-blanc_mont-blanc_15-sunflower/bd_br_mont-blanc_mont-blanc_15-sunflower_s_4.jpg',
    }
];
